(function() {
    'use strict';
  
    function initModalVideoPlayerWithHLS(sectionElement) {
      const section = sectionElement;
      if (!section) return;
  
      const videoWrappers = section.querySelectorAll('.video_selector');
      const isMobile = window.innerWidth <= 767;
  
      function loadHlsJs(callback) {
        if (window.Hls) {
          callback();
          return;
        }
        const script = document.createElement('script');
        script.src = "https://cdn.jsdelivr.net/npm/hls.js@latest";
        script.onload = () => callback();
        document.head.appendChild(script);
      }
  
      videoWrappers.forEach((wrapper) => {
        const video = wrapper.querySelector('video');
        if (!video) return;
        
        // Always check for and remove duplicate poster wrappers
        const existingPosters = wrapper.querySelectorAll('.custom-poster-wrapper');
        existingPosters.forEach(poster => {
          if (poster.parentNode) {
            poster.remove();
          }
        });
        
        // Also check if video already has a poster wrapper reference
        if (video._posterWrapper && video._posterWrapper.parentNode) {
          video._posterWrapper.remove();
          video._posterWrapper = null;
        }
        
        // Only initialize if not already initialized
        if (video.dataset.initialized === 'true') return;
        video.dataset.initialized = 'true';
  
        const getSrc = () => isMobile ? video.dataset.mobileVideo : video.dataset.desktopVideo;
        const getPoster = () => isMobile ? video.dataset.mobilePoster : video.dataset.desktopPoster;
        const shouldAutoplay = () => (isMobile ? video.dataset.autoplayM : video.dataset.autoplay) === 'true';
        const showMute = (isMobile ? video.dataset.muteM : video.dataset.mute) === 'true';
        const muteBtn = wrapper.querySelector('.glb_mute');
        let hls = null;
        let isNativeHLS = false;
        let isVideoLoaded = false;
        
        // Poster layer
        const posterUrl = getPoster();
        
        let posterWrapper = null;
        if (posterUrl && posterUrl.trim() !== '') {
          posterWrapper = document.createElement('picture');
          posterWrapper.className = 'custom-poster-wrapper';
          Object.assign(posterWrapper.style, {
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            zIndex: 1,
            background: `url('${posterUrl}') center center / cover no-repeat`,
            pointerEvents: 'none',
            transition: 'opacity 0.4s ease',
            opacity: 1
          });
  
          wrapper.style.position = 'relative';
          wrapper.appendChild(posterWrapper);
          video._posterWrapper = posterWrapper;
        }
  
        video.setAttribute('muted', '');
        video.setAttribute('playsinline', '');
        video.setAttribute('webkit-playsinline', '');
        video.setAttribute('preload', 'metadata');
        
        video.muted = false;
        if (muteBtn) {
          muteBtn.classList.remove('muted');
        }
  
        function safePlay() {
          const playPromise = video.play();
          if (playPromise && typeof playPromise.then === 'function') {
            playPromise
              .then(() => {
                if (video._posterWrapper) video._posterWrapper.style.opacity = 0;
              })
              .catch(() => {
                if (video._posterWrapper) video._posterWrapper.style.opacity = 1;
              });
          }
        }
        
        const modalId = section.querySelector('[id^="videoModal"]')?.id || 'videoModal';
        const progressBar = section.querySelector('#' + modalId + ' .progress-bar') || section.querySelector('.video-modal .progress-bar');
  
        if (progressBar) {
          video.addEventListener('timeupdate', () => {
            if (video.duration) {
              const progressPercent = (video.currentTime / video.duration) * 100;
              progressBar.style.width = progressPercent + "%";
            }
          });
        }
        
        function loadVideo() {
          const src = getSrc();
          var autoplay = shouldAutoplay();
          isNativeHLS = src.endsWith('.m3u8') && video.canPlayType('application/vnd.apple.mpegurl') !== '';
          
          if (src.endsWith('.m3u8')) {
            if (isNativeHLS) {
              video.src = src;
              video.setAttribute('preload', 'auto');
              video.load();
              isVideoLoaded = true;
              video.addEventListener('loadedmetadata', () => {
                if (autoplay) safePlay();
              }, { once: true });
            } else {
              loadHlsJs(() => {
                if (window.Hls && Hls.isSupported()) {
                  hls = new Hls({ 
                    maxBufferLength: 3,
                    startLevel: -1,      
                    capLevelToPlayerSize: true
                  });
                  hls.loadSource(src);
                  hls.attachMedia(video);
                  video.hlsInstance = hls;
  
                  hls.on(Hls.Events.MANIFEST_PARSED, () => {
                    isVideoLoaded = true;
                    if (autoplay) safePlay();
                  });
                }
              });
            }
          } else {
            const source = document.createElement('source');
            source.src = src;
            source.type = 'video/mp4';
            video.appendChild(source);
            video.load();
            isVideoLoaded = true;
            video.addEventListener('loadedmetadata', () => {
              if (autoplay) safePlay();
            }, { once: true });
          }
  
          if (autoplay) { 
            safePlay();
            video.onended = () => {
              const activeItem = section.querySelector('.product_in_use_slider_item.active');
              if (!activeItem) return;
              const currentThumb = activeItem.querySelector('.video-thumb');
              if (!currentThumb) return;
              const thumbs = [...section.querySelectorAll('.video-thumb')];
              const currentIndex = thumbs.indexOf(currentThumb);
  
              // pick next (or loop to first)
              let nextThumb = thumbs[currentIndex + 1] || thumbs[0];
              // update active class
              section.querySelectorAll('.product_in_use_slider_item.active').forEach(item => item.classList.remove('active'));
              nextThumb.closest('.product_in_use_slider_item')?.classList.add('active');
              // trigger click on next thumb
              nextThumb.click();
            };
          }
        }
        loadVideo();
  
        if (muteBtn && !muteBtn.dataset.listenerAttached) {
          muteBtn.style.display = 'block';
          muteBtn.addEventListener('click', () => {
            video.muted = !video.muted;
            muteBtn.classList.toggle('muted', video.muted);
          });
          muteBtn.dataset.listenerAttached = "true";
        }
      });
    }
  
    function initProductInUseSlider(section) {
      if (!section) return;

      const sliderEl = section.querySelector(".product_in_use_slider");
      if (!sliderEl) return;

      if (sliderEl.dataset.swiperInitialized === 'true') {
        return;
      }

      const desktop = parseInt(sliderEl.dataset.desktop || '4', 10);
      const tablet = parseInt(sliderEl.dataset.tablet || '3', 10);
      const mobile = parseInt(sliderEl.dataset.mobile || '2', 10);
      const swiperPrev = section.querySelector('.swiper-button-prev');
      const swiperNext = section.querySelector('.swiper-button-next');

      function initSwiper() {
        const swiperOptions = {
          slidesPerView: 'auto',
          slidesPerGroup: 1,
          spaceBetween: 5,
          loop: false,
          centeredSlides: false,
          navigation: swiperPrev && swiperNext ? { prevEl: swiperPrev, nextEl: swiperNext } : false,
          breakpoints: {
            768: { spaceBetween: 7.5 },
            1024: { spaceBetween: 5 }
          }
        };
        if (typeof window.FoxTheme !== 'undefined' && typeof window.FoxTheme.Carousel === 'function') {
          try {
            const carousel = new window.FoxTheme.Carousel(sliderEl, swiperOptions);
            carousel.init();
            sliderEl.dataset.swiperInitialized = 'true';
            return true;
          } catch (e) {
            console.warn('Product videos: Carousel init error', e);
          }
        }
        if (typeof window.Swiper === 'function') {
          try {
            new window.Swiper(sliderEl, swiperOptions);
            sliderEl.dataset.swiperInitialized = 'true';
            return true;
          } catch (e) {
            console.warn('Product videos: Swiper init error', e);
          }
        }
        return false;
      }

      if (!initSwiper()) {
        window.addEventListener('load', function () {
          initSwiper();
        });
        setTimeout(function retrySwiper() {
          if (sliderEl.dataset.swiperInitialized !== 'true') {
            initSwiper();
          }
        }, 300);
      }

      // Open modal on thumbnail click
        section.querySelectorAll('.video-thumb').forEach(thumb => {
          if (thumb.dataset.listenerAttached === 'true') return;
          thumb.dataset.listenerAttached = 'true';
          
          thumb.addEventListener('click', () => {
            const src = thumb.dataset.videoSrc;
            const poster = thumb.dataset.poster;
  
            const modalId = section.querySelector('[id^="videoModal"]')?.id || 'videoModal';
            const modal = section.querySelector('#' + modalId) || section.querySelector('.video-modal');
            if (!modal) return;
            
            const video = modal.querySelector('video');
            if (!video) return;
            
            // Reset video
            video.pause();
            if (video.hlsInstance) {
              video.hlsInstance.destroy();
              video.hlsInstance = null;
            }
            video.removeAttribute('src');
            video.load();
            
            // Clear existing sources
            const existingSources = video.querySelectorAll('source');
            existingSources.forEach(s => s.remove());
            
            // Set dataset so init function can pick it up
            video.dataset.desktopVideo = src;
            video.dataset.mobileVideo = src;
            video.dataset.desktopPoster = poster;
            video.dataset.mobilePoster = poster;
            video.dataset.autoplay = 'true';
            video.dataset.autoplayM = 'true';
            video.dataset.mute = 'true';
            video.dataset.muteM = 'true';
            video.removeAttribute('data-initialized');
            
            modal.classList.add('open');

            const progressBar = modal.querySelector('.progress-bar');
            if (progressBar) {
              progressBar.style.width = "0%";
            }
            
            const parentItem = thumb.closest('.product_in_use_slider_item');
            if (parentItem) {
              section.querySelectorAll('.product_in_use_slider_item').forEach(el => el.classList.remove('active')); 
              parentItem.classList.add('active');
            }
            
            // Init video player - pass section element directly
            initModalVideoPlayerWithHLS(section);
          });
        });
  
        function showNext() {
          const activeItem = section.querySelector('.product_in_use_slider_item.active');
          if (!activeItem) return;
  
          const currentThumb = activeItem.querySelector('.video-thumb');
          if (!currentThumb) return;
  
          const thumbs = [...section.querySelectorAll('.video-thumb')];
          const currentIndex = thumbs.indexOf(currentThumb);
  
          // pick next (or loop to first)
          const nextThumb = thumbs[currentIndex + 1] || thumbs[0];
  
          // update active class
          section.querySelectorAll('.product_in_use_slider_item.active')
                .forEach(item => item.classList.remove('active'));
          nextThumb.closest('.product_in_use_slider_item')?.classList.add('active');
  
          // trigger click on next thumb
          nextThumb.click();
        }
        
        function showPrev() {
          const activeItem = section.querySelector('.product_in_use_slider_item.active');
          if (!activeItem) return;
  
          const currentThumb = activeItem.querySelector('.video-thumb');
          if (!currentThumb) return;
  
          const thumbs = [...section.querySelectorAll('.video-thumb')];
          const currentIndex = thumbs.indexOf(currentThumb);
  
          // pick prev (or loop to last)
          const prevThumb = thumbs[currentIndex - 1] || thumbs[thumbs.length - 1];
  
          // update active class
          section.querySelectorAll('.product_in_use_slider_item.active')
                .forEach(item => item.classList.remove('active'));
          prevThumb.closest('.product_in_use_slider_item')?.classList.add('active');
  
          // trigger click on prev thumb
          prevThumb.click();
        }
        
        const nextBtn = section.querySelector('.glb_next');
        const prevBtn = section.querySelector('.glb_prev');
        
        if (nextBtn && !nextBtn.dataset.listenerAttached) {
          nextBtn.dataset.listenerAttached = 'true';
          nextBtn.addEventListener('click', showNext);
        }
        
        if (prevBtn && !prevBtn.dataset.listenerAttached) {
          prevBtn.dataset.listenerAttached = 'true';
          prevBtn.addEventListener('click', showPrev);
        }
  
        // Close modal
        const modalId = section.querySelector('[id^="videoModal"]')?.id || 'videoModal';
        section.querySelectorAll('#' + modalId + ' .modal-close, #' + modalId + ' .modal-overlay, .video-modal .modal-close, .video-modal .modal-overlay').forEach(el => {
          if (el.dataset.listenerAttached === 'true') return;
          el.dataset.listenerAttached = 'true';
          
          el.addEventListener('click', () => {
            const modalId = section.querySelector('[id^="videoModal"]')?.id || 'videoModal';
            const modal = section.querySelector('#' + modalId) || section.querySelector('.video-modal');
            const video = modal?.querySelector('video');
            if (video) {
              video.pause();
              if (video.hlsInstance) {
                video.hlsInstance.destroy();
                video.hlsInstance = null;
              }
              // Clear video source
              video.removeAttribute('src');
              const sources = video.querySelectorAll('source');
              sources.forEach(s => s.remove());
              video.load();
            }
            modal?.classList.remove('open');
          });
        });
    }
  
    // Initialize on page load
    function initAll() {
      document.querySelectorAll('.product_in_use').forEach(section => {
        initProductInUseSlider(section);
      });
    }
  
    // Initialize when DOM is ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
  
    // Re-initialize when sections are loaded dynamically
    document.addEventListener('shopify:section:load', function(event) {
      const section = event.target.querySelector('.product_in_use');
      if (section) {
        initProductInUseSlider(section);
      }
    });
  
    // Also listen for custom section load events
    document.addEventListener('page:loaded', function() {
      initAll();
    });
  
  })();
  